import { useTranslation } from "react-i18next";

export default function BrowseHeaderWeb() {
  const { t } = useTranslation();
  return (
    <div className="flex items-end justify-between">
      <div className="flex flex-col font-inter tracking-wider">
        <div className="text-font-active text-sm uppercase">{t("Landing.browse.label")}</div>
        <div className="flex flex-col md:text-6xl text-font-default gap-2">
          <div>{t("Landing.browse.titleLine1")}</div>
          <div>{t("Landing.browse.titleLine2")}</div>
        </div>
      </div>
      <div className="text-font-subtle flex flex-col text-sm">
        <div>{t("Landing.browse.descriptionLine1")}</div>
        <div>{t("Landing.browse.descriptionLine2")}</div>
      </div>
    </div>
  );
}
